import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

type ProgressSquaresProps = {
  $progress: number;
};

export const ProgressSquares = styled.span<ProgressSquaresProps>`
  color: ${COLOR.IRON};
  font-size: 24px;
  margin: 0;
  position: relative;
  display: inline-block;
  top: -8px;
  &:before {
    content: '■■■■■■■■■■';
    opacity: 0.3;
  }
  &:after {
    width: ${({ $progress }) => $progress + '%'};
    color: ${COLOR.BATTERY_TECH_REVIEW};
    content: '■■■■■■■■■■';
    position: absolute;
    z-index: 1;
    display: block;
    left: 0;
    top: 0;
    overflow: hidden;
  }
`;

export const ProgressWrapper = styled.div`
  height: 24px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

export const Text = styled.span`
  font-size: 14px;
  font-weight: bold;
  margin-left: 15px;
`;
